import { render, staticRenderFns } from "./helpActivity.vue?vue&type=template&id=4a3150c0&scoped=true&"
import script from "./helpActivity.vue?vue&type=script&lang=js&"
export * from "./helpActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3150c0",
  null
  
)

export default component.exports